import React from 'react';
import { APP_NAME } from '@apps/config';
import ForgotPasswordScreen from '@apps/screens/ForgotPassword';
import Head from 'next/head';
// import useTranslation from 'next-translate/useTranslation';

const ForgotPasswordPage: React.FC = () => {
  // const { t } = useTranslation('screen');
  return (
    <>
      <Head>
        <title>{`Forgot Password - ${APP_NAME}`}</title>
      </Head>
      <ForgotPasswordScreen />
    </>
  );
};

export default ForgotPasswordPage;
